import { render, staticRenderFns } from "./UnitInputs.vue?vue&type=template&id=0550c1bc&scoped=true&"
import script from "./UnitInputs.vue?vue&type=script&lang=js&"
export * from "./UnitInputs.vue?vue&type=script&lang=js&"
import style0 from "./UnitInputs.vue?vue&type=style&index=0&id=0550c1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0550c1bc",
  null
  
)

export default component.exports